import styled from 'styled-components';

import React from 'react';

const ButtonStyled = styled.button`
    padding: 8px 16px !important;
    background-color: ${(props) => props.theme.colorButtonPrimary};
    color: ${(props) => props.theme.colorWhite};
    border: none;
    border-radius: 28px;
    cursor: pointer;
    min-height: 35px !important;
    font-size: 12px !important;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
    flex-shrink: 0;
    box-sizing: border-box;

    &:hover {
        background-color: ${(props) => props.theme.colorButtonPrimaryHover};
    }
    &:focus {
        outline: none;
    }
    &:disabled {
        background-color: ${(props) => props.theme.colorButtonPrimaryDisable};
        cursor: not-allowed;
    }
`;

const Button = ({ onClick, children, className = '' , disabled, type = 'button' }) => {
    return (
        <ButtonStyled className={className} onClick={onClick} disabled = {disabled} type={type}>
            {children}
        </ButtonStyled>
    );
};

export default Button;
